import palette from 'theme/palette';

// Palette lifted from the monitoring prototype's Review Price modal (Tailwind slate + navy).
export const reviewPriceDialogColors = {
  navy: '#013e73',
  navyHover: '#0a4d88',
  border: '#e3e8f0',
  slate800: '#1e293b',
  slate700: '#334155',
  slate500: '#64748b',
  tableHeaderBackground: '#f1f5f9',
  error: palette.error.main,
  errorSurface: palette.error.veryLight,
};
